module.exports = __webpack_public_path__ + "img/34d8f51.png";